// extracted by mini-css-extract-plugin
export default {"lightbox":"LightboxSingle_lightbox__5UdHE","fullscreenImage":"LightboxSingle_fullscreenImage__lfcO+","closeBtn":"LightboxSingle_closeBtn__IajaS"};